import styled from 'styled-components';


export const Wrap = styled.div`
  position:relative;
  display:flex;
  align-items:center;
  justify-content:space-between;
  height: 1.06rem;
  padding:0 .54rem;
  .logo{
    width:2.5rem;
    height:.49rem;
  }
  .menuBtn{
    display:flex;
    flex-direction:column;
    width:.47rem;
    height:.31rem;
    .menu-item{
      height:2px;
      background-color:#005bab;
      border-radius:3px;
      :nth-child(2){
        margin:5px 0
      }
      transition:.6s all;
    }
    &.close .menu-item:nth-child(1){
      transform:translateY(7px) rotate(45deg);
    }
    &.close .menu-item:nth-child(2){
      opacity:0;
    }
    &.close .menu-item:nth-child(3){
      transform:translateY(-7px) rotate(-45deg);
    }
  }
  .menuList{
    position:absolute;
    z-index:1;
    top:1.06rem;
    left:0;
    width:100%;
    height:calc(13.34rem - 1.08rem);
    padding:0 .54rem;
    background:rgba(255,255,255,0.9);
    transform:translateX(100%);
    opacity:0;
    transition:1s all;
    
    &.close{
      
      opacity:1;
      transform:translateX(0);
    }
    .menuList-item{
      display:flex;
      justify-content:space-between;
      align-items:center;
      border-bottom:1px solid #000;
      line-height:3.5;
      h5{
        font-size:.28rem;
      }
      h5:nth-child(2){
        width:.32rem;
      }
    }
  }
`

